import React from 'react';
import {Button} from 'antd';
import styled from 'styled-components';

const MoreButton = styled(Button).attrs({icon: <i className="far fa-ellipsis-v" />, shape: 'circle', type: 'link'})`
  color: rgba(0, 0, 0, 0.54);
`;

export default MoreButton;
